var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-group quantity" }, [
    _c("input", {
      ref: "quantityInputField",
      staticClass: "form-control quantity__form",
      attrs: { type: "text", disabled: _vm.waiting },
      domProps: { value: _vm.displayValue },
      on: {
        change: function($event) {
          return _vm.setValue($event.target.value)
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "plus-minus-wrapper" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-sm quantity__btn quantity__btn--last",
          class: { disabled: _vm.isMaximum || _vm.waiting },
          attrs: {
            title: _vm.maximumHint,
            "aria-label": _vm.$translate(
              "Ceres::Template.itemQuantityInputIncrease"
            )
          },
          on: {
            click: function($event) {
              return _vm.increaseValue()
            }
          }
        },
        [
          _c(
            "svg",
            { staticClass: "icon icon-plus", attrs: { fill: "currentColor" } },
            [_c("use", { attrs: { "xlink:href": "#plus" } })]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-sm quantity__btn quantity__btn--first",
          class: { disabled: _vm.isMinimum || _vm.waiting },
          attrs: {
            title: _vm.minimumHint,
            "aria-label": _vm.$translate(
              "Ceres::Template.itemQuantityInputDecrease"
            )
          },
          on: {
            click: function($event) {
              return _vm.decreaseValue()
            }
          }
        },
        [
          _c(
            "svg",
            { staticClass: "icon icon-minus", attrs: { fill: "currentColor" } },
            [_c("use", { attrs: { "xlink:href": "#minus" } })]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }